import { images } from '../constants';

const testimonials = [
    { 
        id: 1,
        image: images.testimonial1,
        name: 'Allen Hill',
        title: 'Tea Enthusiast',
        content: 'The tea selection here is absolutely delightful! From the aroma to the taste, every cup is a treat. I especially love the herbal blends—they help me relax after a long day.',
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Liz Amos',
        title: 'Daily Visitor',
        content: 'A cozy spot for tea lovers! The atmosphere is peaceful, and the matcha lattes are my favorite. Staff are knowledgeable and always suggest the perfect brew for my mood.',
    },
    {  
        id: 3,
        image: images.testimonial3,
        name: 'Tom Emmett',
        title: 'Chai Lover',
        content: 'I keep coming back for the Masala Chai—it’s authentic, spicy, and perfectly brewed. This place has truly mastered the art of tea-making.',
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Janice Parker',
        title: 'Tea Collector',
        content: 'Their loose-leaf tea collection is top-notch! I’ve discovered rare blends and quality leaves that are hard to find elsewhere. A hidden gem for tea aficionados.',
    },
];

export default testimonials;